import { IconProps } from '.';

export const PieChartHighlightIcon = ({ className, color = 'black' }: IconProps) => {
  return (
    <svg
      className={className}
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.4442 0.685084C11.3522 0.232792 10.1819 0 9 0V9L18 9C18 7.8181 17.7672 6.64778 17.3149 5.55585C16.8626 4.46392 16.1997 3.47177 15.364 2.63604C14.5282 1.80031 13.5361 1.13738 12.4442 0.685084ZM7.5 10.5H9H13.5H15C15 11.0063 14.9488 11.5087 14.8485 12C14.655 12.948 14.2788 13.8544 13.736 14.6668C12.9119 15.9001 11.7406 16.8614 10.3701 17.4291C8.99968 17.9968 7.49168 18.1453 6.03683 17.8559C4.58197 17.5665 3.2456 16.8522 2.1967 15.8033C1.14781 14.7544 0.433503 13.418 0.144114 11.9632C-0.145275 10.5083 0.00324965 9.00032 0.570907 7.62987C1.13856 6.25943 2.09986 5.08809 3.33323 4.26398C4.14561 3.72116 5.052 3.34504 6 3.15153C6.49126 3.05125 6.99369 3 7.5 3V4.5V9V10.5ZM7.5 12H13.3095C13.1418 12.6495 12.8655 13.2697 12.4888 13.8334C11.8295 14.8201 10.8925 15.5892 9.7961 16.0433C8.69975 16.4974 7.49335 16.6162 6.32946 16.3847C5.16558 16.1532 4.09648 15.5818 3.25736 14.7426C2.41825 13.9035 1.8468 12.8344 1.61529 11.6705C1.38378 10.5067 1.5026 9.30026 1.95673 8.2039C2.41085 7.10754 3.17989 6.17047 4.16658 5.51118C4.73027 5.13454 5.35052 4.85822 6 4.69052V10.5V12H7.5Z'
        fill={color}
      />
    </svg>
  );
};
